export const RecordNotFound = () => {
  return (
    <div className="flex items-center justify-center pt-[10%] w-full">
      <img
        src="/images/not-found-record.jpg"
        className="max-w-[138px]"
        alt="Record Not Found"
      />
    </div>
  );
};
